import React from "react";
import { Fingerprint, ShieldCheck } from "lucide-react";

export default function PuvioBadge({ puvioId, level = "unverified", className = "" }) {
  const short = (puvioId || "").slice(0, 12) + (puvioId && puvioId.length > 12 ? "…" : "");
  return (
    <div className={`inline-flex items-center gap-2 rounded-full bg-white/10 backdrop-blur border border-white/15 px-2.5 py-1 ${className}`} data-testid="puvio-badge">
      <Fingerprint size={11} className="opacity-90" />
      <span className="text-[10px] font-extrabold tracking-wider uppercase opacity-90">Puvio</span>
      <span className="text-[10px] font-mono opacity-80">{short}</span>
      <ShieldCheck size={11} className="opacity-80" />
    </div>
  );
}
